import React, { useState } from 'react';

const Tooltip = ({ children, content, position = 'top', className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2'
  };

  const tooltipClasses = `
    absolute z-50 px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm
    transition-opacity duration-300 ${positionClasses[position]}
    ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}
  `;

  return (
    <div 
      className={`relative inline-block ${className}`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
    >
      {children}
      <div className={tooltipClasses} role="tooltip">
        <div className="relative">
          {content}
          <div 
            className={`
              absolute w-3 h-3 bg-gray-900 rotate-45
              ${position === 'top' ? 'bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2' : ''}
              ${position === 'bottom' ? 'top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2' : ''}
              ${position === 'left' ? 'right-0 top-1/2 transform -translate-y-1/2 translate-x-1/2' : ''}
              ${position === 'right' ? 'left-0 top-1/2 transform -translate-y-1/2 -translate-x-1/2' : ''}
            `}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Tooltip;